import { getHost } from "@/engine/transport";

/** Saves text through the desktop shell when present, otherwise triggers a browser download. */
export async function downloadText(name: string, content: string, type = "text/plain"): Promise<void> {
  const host = getHost();
  if (host?.shell?.saveFile) {
    await host.shell.saveFile({ defaultName: name, content });
    return;
  }
  const blob = new Blob([content], { type });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = name;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

/** Reads a file through the desktop picker when present, otherwise with an <input type=file>. */
export function pickTextFile(extensions: string[]): Promise<{ name: string; content: string } | null> {
  const host = getHost();
  if (host?.shell?.pickFile) return host.shell.pickFile({ extensions });
  return new Promise((resolve) => {
    const input = document.createElement("input");
    input.type = "file";
    input.accept = extensions.map((e) => `.${e}`).join(",");
    input.onchange = () => {
      const f = input.files?.[0];
      if (!f) return resolve(null);
      f.text().then((content) => resolve({ name: f.name, content })).catch(() => resolve(null));
    };
    input.click();
  });
}
